<ng-container *ngIf="vm$ | async as vm">
	<div class="flex flex-1">
		<div *ngIf="vm.pins && !searching && !error" class="flex flex-col flex-1">
			<div
				*ngIf="!searchingByOwners"
				class="flex flex-1 py-4 -mx-6 mb-2 justify-center items-center bg-grey-lightest max-h-14"
			>
				Search results for {{ name }}
			</div>
			<div class="flex justify-between items-center">
				<div class="flex-initial">
					<app-input
						type="text"
						label="Filter search results by"
						name="price"
						(keyup)="applyFilter($event.target.value)"
						class="mb-2"
						[testHook]="testHooks.FilterSearchResultsBy"
					></app-input>
				</div>
				<div class="flex-initial flex">
					<div class="mr-2">
						<app-checkbox
							type="clear"
							[(ngModel)]="vm.purchaseDeleted"
							[testHook]="testHooks.IncludeDeletedInstrumentsCheckbox"
							>Include deleted instruments</app-checkbox
						>
					</div>
				</div>
			</div>
			<span *ngIf="searchingByOwners" class="mb-2">
				Search results for {{ name }}</span
			>
			<table
				mat-table
				[dataSource]="vm.dataSource"
				[trackBy]="trackByUid"
				matSort
				class="animate w-full dashboard-table"
			>
				<ng-container matColumnDef="pin">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>Pin</th>
					<td mat-cell *matCellDef="let element">{{ element.pin }}</td>
				</ng-container>

				<ng-container matColumnDef="registrationType">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>
						Registration Type
					</th>
					<td mat-cell *matCellDef="let element">
						{{ element.registration_type }}
					</td>
				</ng-container>

				<ng-container matColumnDef="status">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
					<td mat-cell *matCellDef="let element">{{ element.status_ind }}</td>
				</ng-container>

				<ng-container matColumnDef="address">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
					<td mat-cell *matCellDef="let element">
						{{ element.address.area }} {{ element.address.street_number }}
						{{ element.address.street_name }}
						{{ element.address.street_suffix }}
						{{ element.address.unit_number }} {{ element.address.unit_type }}
					</td>
				</ng-container>

				<ng-container matColumnDef="legalDesc">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>
						Legal description
					</th>
					<td mat-cell *matCellDef="let element">{{ element.legal_desc }}</td>
				</ng-container>

				<ng-container matColumnDef="purchase">
					<th mat-header-cell *matHeaderCellDef mat-sort-header></th>
					<td mat-cell *matCellDef="let element">
						<app-button
							size="small"
							*ngIf="
								pinPurchaseActionState(element.pin) ===
								purchaseActionState.PURCHASING
							"
							disabled="true"
							[loading]="true"
							[testHook]="testHooks.PurchasingButton"
							>Purchasing</app-button
						>
						<app-button
							size="small"
							*ngIf="
								pinPurchaseActionState(element.pin) ===
								purchaseActionState.UNPURCHASED
							"
							teranetLoginGuard
							[icon]="ICON.DOLLAR"
							(click)="purchasePin(element)"
							[testHook]="testHooks.PurchaseButton"
							>Purchase</app-button
						>
						<div
							class="flex gap-2 justify-center items-center"
							*ngIf="
								pinPurchaseActionState(element.pin) ===
								purchaseActionState.PURCHASED
							"
							[testHook]="testHooks.PurchaseDoneDiv"
						>
							<app-icon
								[icon]="ICON.CIRCLE_CHECK"
								class="text-green"
							></app-icon>
							<div class="text-grey">Purchased</div>
						</div>
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr
					mat-row
					*matRowDef="let row; columns: displayedColumns"
					class="animate cursor-pointer"
				></tr>
			</table>
			<div class="relative flex flex-1">
				<div
					*ngIf="vm.showContinueMessage && !isOverview"
					class="fixed bottom-24 right-64 transform translate-x-1/2 z-50"
				>
					<atomic-message-bar [type]="'info'" [testHook]="testHooks.MessageBar">
						You must select continue to see your purchased parcel(s)
					</atomic-message-bar>
				</div>
			</div>
		</div>
		<div
			*ngIf="!error && searching"
			class="flex flex-1 -mx-6 py-4 justify-center items-center bg-grey-lightest"
			[testHook]="testHooks.SearchingDiv"
		>
			<app-icon [icon]="ICON.LOADING" [spin]="true" class="mr-5"></app-icon>
			Searching PINs...
		</div>
		<div
			*ngIf="!error && vm.pins?.pin_infos?.length === 0"
			class="flex flex-1 -mx-6 py-4 justify-center items-center bg-grey-lightest"
		>
			No matching PINs found
		</div>
		<div
			*ngIf="error"
			class="flex flex-1 -mx-6 py-4 justify-center items-center flex-col bg-grey-lightest"
		>
			<div>Unable to retrieve PINs</div>
			<div class="mt-10">{{ error }}</div>
		</div>
	</div>
</ng-container>
